module.exports = ['$scope', '$state', 'User', '$translate', '$utils',
  function ($scope, $state, User, $translate, $utils) {
    $scope.goSubFrame = function(frame, param = {}) {
      switch (param.type) {
        case 'ent':
          LA.track('A3C1')
          break
        case 'per':
          LA.track('A3C2')
          break
      }
      $state.go(frame, param)
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/netFolder/netFolderCtrl.js